import { mdiPoll } from '@mdi/js'

export default [
  {
    title: 'Leaderboard',
    to: 'leaderboard-list',
    icon: mdiPoll,
  },
]
